"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const reportWebVitals_1 = __importDefault(require("./src/reportWebVitals"));
const App_1 = __importDefault(require("./src/App")); // App 컴포넌트를 import 해야합니다.
const root = client_1.default.createRoot(document.getElementById('root'));
root.render(react_1.default.createElement(App_1.default, null));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, reportWebVitals_1.default)();
